/**
 * Extrae el identificador de usuario del JWT (sin verificar firma).
 *
 * @module presentation/shared/jwtUserId
 */

import { AppConfig } from '../../config.js';

export function getJwtUserId() {
  try {
    const token = AppConfig.token;
    if (!token) return 'anon';
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.sub || payload.uid || payload.user_id || 'anon';
  } catch {
    return 'anon';
  }
}
